import { Skeleton, useToast } from '@chakra-ui/react';
import React from 'react';

import {
  date as commonDate,
  utils as commonUtils,
} from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

import {
  BorrowingBasePipelineSingleProgressBreakdownGQLType,
  StepStatusEnumGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

import { VerificationStatusIcon } from './VerificationIcons';
import { VerificationProgressTracker } from './VerificationProgressTracker';
import { VerificationsAccordion } from './VerificationsTemplate';
import { errorToastConfig } from 'packages/common-frontend/constants';
import { useGetCreditFacilityQuery } from 'packages/credit-facility/requests/requests.gql.generated';

type VerificationCalculateAccordionProps = {
  selectedCreditFacilityId: string;
  selectedReportingDate: Util.FullDateStr;
  isExpanded: boolean;
  overallStatus: StepStatusEnumGQLType;
  progressBreakdownStatus: BorrowingBasePipelineSingleProgressBreakdownGQLType[];
};
export const VerificationCalculateAccordion = ({
  selectedCreditFacilityId,
  selectedReportingDate,
  isExpanded,
  overallStatus,
  progressBreakdownStatus,
}: VerificationCalculateAccordionProps) => {
  const toast = useToast();
  const {
    data: creditFacilityData,
    loading: creditFacilityLoading,
  } = useGetCreditFacilityQuery({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = commonUtils.EnvUtils.isProduction()
        ? 'An unexpected error occurred. Please contact Finley for support.'
        : err.message;
      toast(errorToastConfig);
    },
    variables: { creditFacilityId: selectedCreditFacilityId },
  });

  if (!creditFacilityData || creditFacilityLoading) {
    return (
      <Skeleton
        data-testid="loading-verification-calculate-accordian"
        height="600px"
      />
    );
  }
  const {
    creditFacility: { formattedSlug },
  } = creditFacilityData;

  const header = `Calculate ${commonDate.fullDateStrToSlashedDateStr(
    selectedReportingDate,
    commonDate.formatSlashedDateStr,
  )} Servicer Report for ${formattedSlug}`;

  return (
    <VerificationsAccordion
      header={header}
      icon={<VerificationStatusIcon status={overallStatus} />}
      isExpanded={isExpanded}
    >
      <VerificationProgressTracker
        progressBreakdown={progressBreakdownStatus}
      />
    </VerificationsAccordion>
  );
};
